/**
 * Path: packages/frontend/src/main.ts
 * Task: Bootstraps the Vue application, registers plugins (Vuetify, Pinia), and mounts the Vue Router.
 * Update: Registered global v-can directive for capability-based UI access control.
 */
import { createApp } from 'vue';
import App from './App.vue';
import { registerPlugins } from './core/plugins';
import router from './router';
import { canDirective } from './core/directives/can';

// IMPORTANT: Include global styling
import './core/styles/global.css';

const app = createApp(App);

// Register Base Plugins (Vuetify, Pinia)
registerPlugins(app);

// Register global authorization directive (v-can)
app.directive('can', canDirective);

// Mount Vue Router for Client-side state routing
app.use(router);
app.mount('#app');
